export default __webpack_public_path__ + "static/compareItemImg5-58150a9f5c552708e7c67ef9e7e3d295.webp";